//获取基础路径
let basePath = ''
if (!window.location.origin) {
    basePath = window.location.protocol + '//' + window.location.host + '/'
} else {
    basePath = window.location.origin + '/'
}
const version = '1.0.0'
export default {
    //基础路径
    basePath: basePath,
    version: version
}